"use strict";

let Chart = {};
let Data = {};
